import { RenderableColumnDefinition } from "components/grid/gridTypings";
import { IColumnProps } from "devextreme-react/data-grid";
import Header from "./Header";
import TableSetGrid from "./TableSetGrid";
import { useStyles } from "./tableSetStyle";

type TableSetItemProps<TVariables, TTable> = {
  columnDefs: (
    schemaName: string
  ) => RenderableColumnDefinition<IColumnProps, {}>[];
  dataKey?: string;
  calculationId?: string;
  useCaseKey: string;
  useCaseVersion?: string | null;
  loadData: (variables: TVariables) => Promise<TTable | null>;
  toCalculationResultTable?: (name: string) => string;
  backgroundColor: string;
  name: string;
};

function TableSetItem<TVariables, TTable>({
  columnDefs,
  dataKey,
  calculationId,
  useCaseKey,
  useCaseVersion = null,
  loadData,
  toCalculationResultTable,
  backgroundColor,
  name
}: TableSetItemProps<TVariables, TTable>) {
  const { flexContainer, tableView } = useStyles({});
  return (
    <div className={flexContainer}>
      <div key={name} className={tableView}>
        <Header
          name={name}
          tableDeepLinks={true}
          toCalculationResultTable={
            toCalculationResultTable && toCalculationResultTable(name)
          }
          backgroundColor={backgroundColor}
        />
        <TableSetGrid<TVariables, TTable>
          key={name}
          dataKey={dataKey}
          columnDefs={columnDefs}
          name={name}
          useCaseKey={useCaseKey}
          useCaseVersion={useCaseVersion}
          calculationId={calculationId}
          loadData={loadData}
        />
      </div>
    </div>
  );
}
export default TableSetItem;
